import { ProfileSearchSchema } from '@milestone-portal/schema/search.schema';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { PrivateProfileSkeleton } from './-components/pending/PrivateProfileSkeleton';
import { PrivateProfile } from './-components/PrivateProfile';
import { PrivateProfileContext } from './-logic/PrivateProfileContext';
import { usePrivateProfile } from './-logic/usePrivateProfile';

export const Route = createFileRoute('/_authed/profile/')({
  component: PrivateProfilePage,
  pendingComponent: PrivateProfileSkeleton,
  validateSearch: zodValidator(ProfileSearchSchema),
});

function PrivateProfilePage() {
  return (
    <PrivateProfileContext.Provider value={usePrivateProfile()}>
      <PrivateProfile />
    </PrivateProfileContext.Provider>
  );
}
